import { select } from '@js/util/select'

// Handle clicks on the <h1> arrow after a hero to be scrollable
// This is a bit of a hacky workaround because the arrow actually is a ::before element
// which cannot receive onclick listeners.
select('.hero + .page-section h1:not([class]):first-child', headlineElement => {
  /**
   * @param {PointerEvent} event
   */
  const clickHandler = event => {
    const headlineElementStyle = getComputedStyle(headlineElement)
    const rightSide = headlineElementStyle.flexDirection === 'row-reverse'

    const headlineElementBeforeStyle = getComputedStyle(headlineElement, 'before')
    const maximumOffset = rightSide
      ? parseFloat(headlineElementBeforeStyle.width) +
        parseFloat(headlineElementBeforeStyle.paddingLeft)
      : parseFloat(headlineElementBeforeStyle.width) +
        parseFloat(headlineElementBeforeStyle.paddingRight)

    if (
      rightSide
        ? event.offsetX < parseFloat(headlineElementStyle.width) - maximumOffset
        : event.offsetX > maximumOffset
    )
      return

    const section = headlineElement.closest('.page-section')

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }

  headlineElement.addEventListener('click', clickHandler)

  return () => {
    headlineElement.removeEventListener('click', clickHandler)
  }
})
